module.exports = __webpack_public_path__ + "img/capability-slider-img-2.70a496a7.png";